import React, { useEffect, useState,  } from 'react'
import { Container, Row, Col, Button, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../../context/auth/useAuth'
import { Link } from 'react-router-dom'
import { addProduct, editProduct, getProducts, removeProduct } from '../../../../actions/productsActions'
import { getRestaurants } from '../../../../actions/restaurantsActions'
import { CustomDataTable } from '../../../../components/design/Datatables/CustomDataTable'
import AllergensComponent from '../../../../components/allergens'
import Swal from 'sweetalert2'
import ProductForm from '../../../../components/forms/products/ProductForm'

export default function Products() {
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()
	const {allergensTextIcons} = AllergensComponent()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

	const {products, resultproduct, total} = useSelector(state=>state.products)
    const {restaurants} = useSelector(state=>state.restaurants)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [imageAux, setImage] = useState(null)

    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

	useEffect(() => {
		if(client){
			dispatch(getProducts(page, limit, search))
            dispatch(getRestaurants())
		}
	},[dispatch, t, client])

    useEffect(() => {
        if (client) {
            dispatch(getProducts(page, limit, search))
        }
    }, [page, limit, search])

    useEffect(() => {
        setTotalRows(total || 0)
    }, [total])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({
            name: '',
            price: 0,
            supplement: 0,
            isComplement: false,
            type: 'Dish',
            allergens: [],
            prices: [],
            supplements: []
        })
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleCheckboxChange = (target) => {
        setFormState({
            ...formState,
            isComplement: target.target.checked
        })
    }

    const handleSelect = (optionselected) => {
        setFormState({
            ...formState,
            type: optionselected.target.value
        })
    }

    const handleSelectChange = async(arrayAllergens) => {
        setFormState({
            ...formState,
            allergens: arrayAllergens
        })
    }

    const handleRestaurantSupplementChange = (restaurantId, price) => {
        setFormState((prevState) => {
            const updatedSupplements = prevState.supplements.some(p => p.restaurant === restaurantId)
                ? prevState.supplements.map((p) =>
                    p.restaurant === restaurantId ? { ...p, price: parseFloat(price) || 0 } : p
                  )
                : [...prevState.supplements, { restaurant: restaurantId, price: parseFloat(price) || 0 }]

            return { ...prevState, supplements: updatedSupplements }
        })
    }
    const handleRestaurantPriceChange = (restaurantId, price) => {
        setFormState((prevState) => {
            const updatedPrices = prevState.prices.some(p => p.restaurant === restaurantId)
                ? prevState.prices.map((p) =>
                    p.restaurant === restaurantId ? { ...p, price: parseFloat(price) || 0 } : p
                  )
                : [...prevState.prices, { restaurant: restaurantId, price: parseFloat(price) || 0 }]

            return { ...prevState, prices: updatedPrices }
        })
    }

    const handleImage = (e)=>{
		setImage(e.target.files[0])
    }

    const selectProduct = (product) => {
        setIsAddingOrEditing('editing')
        let allergensArr = product.allergens.map(allergen => {
            return allergensTextIcons.find(p => p.value === allergen)
        })
        setFormState({...product, allergens: allergensArr})
        setImage(product.photo)
        setModalShow(true)
    }
    const deleteProduct = (product) => {
        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.yes'),
            cancelButtonText: t('global.no'),
            icon: 'warning',
            text: t('admin.products.areyousuredelete')
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(removeProduct(product._id))
            }
        })
    }

    const handleSubmit = async(e) => {
        e.preventDefault()
        setIsRegistering(true)
        let arrayAllergens = formState?.allergens.map(allergen => {
            return allergen.value
        })
        if(isAddingOrEditing==='editing'){
            dispatch(editProduct(imageAux, {
                ...formState,
                allergens: arrayAllergens
            }, formState._id))
        }else{
            dispatch(addProduct(imageAux, {
                ...formState,
                allergens: arrayAllergens
            }))
        }
        setIsRegistering(false)
    }

    useEffect(() => {
        if(resultproduct){
            switch (resultproduct) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.products.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setImage(null)
                    })
                    break;
                case 'name':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'warning',
                        text: t('admin.products.nameduplicated')
                    })
                    break;
                case 'deletesuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.products.deletesuccess')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultproduct])

	const columnsProducts = [
		{
			name: t('admin.products.name'),
			cell: product =>
                product.photo 
                    ?
                        <Row className='align-items-center cursor' onClick={() => selectProduct(product)}>
                            <Col xs={4}>
                                <img className='img-profile w-100' alt='preview' src={product.photo}/>
                            </Col>
                            <Col xs={8}>{product.name}</Col>
                        </Row>
                    :
                        <div className='cursor' onClick={() => selectProduct(product)}>{product.name}</div>
                    ,
			selector: (product) => product.name,
			sortable: true,
		},{
			name: t('admin.products.typeproduct'),
			cell: product =>
				<div>
					{t('admin.products.'+product.type.toLowerCase())}
				</div>,
			selector: (product) => product.type,
			sortable: true,
		},{
			name: t('admin.products.allergens'),
			cell: product =>
				<div className='text-start'>
					{product.allergens?.map((allergen, key) => {
                        return <div key={key}><img src={`../images/allergens/${allergen}.svg`} alt={t('admin.products.'+allergen)} height="30px" width="30px"/> {t('admin.products.'+allergen)}</div>
                    })}
				</div>,
			selector: (product) => product.allergens,
			sortable: true,
		},{
            name: t('admin.products.supplements'),
            width: "20%",
            cell: product => (
                <div className='text-start'>
                    {restaurants
                        ?.filter(restaurant =>
                            product?.supplements?.some(supp => supp.restaurant === restaurant._id && supp.price)
                        )
                        .map(restaurant => {
                            const supplement = product.supplements.find(
                                supp => supp.restaurant === restaurant._id
                            );

                            if (!supplement?.price) return null;

                            const formattedPrice = new Intl.NumberFormat('es-ES', {
                                style: 'currency',
                                currency: 'EUR',
                                minimumFractionDigits: 2,
                            }).format(supplement.price);

                            return (
                                <div key={restaurant._id}>
                                    {restaurant.name}<br/><strong>{formattedPrice}</strong>
                                </div>
                            );
                        })}
                </div>
            ),
            sortable: true,
        },{
            name: t('admin.products.complements'),
            style: {
                textAlign: 'left',
            },
            width: "20%",
            cell: product => (
                <div className='text-start'>
                    {restaurants
                        ?.filter(restaurant =>
                            product?.prices?.some(p => p.restaurant === restaurant._id && p.price)
                        )
                        .map(restaurant => {
                            const price = product.prices.find(
                                p => p.restaurant === restaurant._id
                            );

                            if (!price?.price) return null;

                            const formattedPrice = new Intl.NumberFormat('es-ES', {
                                style: 'currency',
                                currency: 'EUR',
                                minimumFractionDigits: 2,
                            }).format(price.price);

                            return (
                                <div key={restaurant._id} >
                                    {restaurant.name}<br/><strong>{formattedPrice}</strong>
                                </div>
                            );
                        })}
                </div>
            ),
            sortable: true,
        },{
			name: '',
			cell: product =>
				<div className='d-flex justify-content-center'>
                    <div className='cursor mx-3' onClick={() => selectProduct(product)}>
                        <i className='fas fa-pencil'></i>
                    </div>
                    <div className='cursor mx-3' onClick={() => deleteProduct(product)}>
                        <i className='fas fa-trash'></i>
                    </div>
				</div>,
			sortable: false,
		}
	]

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/admin/menusdashboard">
                        <img src="../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.products.products')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5 mb-4">
                <Button variant='primary' type="submit" className="btn-primary my-2 button-withicon" onClick={() => openModal()}>
                    <label className='label-button'>{t('admin.products.createproduct')}</label>
                </Button>
            </Row>
            <Row >
                <Col>
                    <div className="d-flex my-2">
                        <input
                            type="text"
                            className="form-control me-2"
                            placeholder={t("datatables.buscar")}
                            value={searchAux || ""}
                            onChange={e => {
                                setSearchAux(e.target.value);
                                setPage(1);
                            }}
                            onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                        />
                        <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                    </div>
                    {products?.length > 0 ?
                        <CustomDataTable
                            columns={columnsProducts}
                            data={products}
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            searchable={'custom'}
                            searchText={search}
                            onChangeRowsPerPage={(newLimit) => {
                                setLimit(newLimit)
                                setPage(1)
                            }}
                            onChangePage={(newPage) => {
                                setPage(newPage)
                            }}
                        />
                    :
                        <h4 className='mt-4'>{t('admin.products.thereisnotproducts')}</h4>
                    }
                </Col>
            </Row>
            <Modal show={modalShow} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    <i className='fa fa-times cursor' onClick={() => setModalShow(false)}></i>
                </Modal.Header>
                <Modal.Body>
                    <div className='text-center'>
                        <label className='sd-label-create'>
                        {isAddingOrEditing==='adding'
                            ?
                            t('admin.products.createproduct')
                            :
                            t('admin.products.editproduct')
                        }
                        </label>
                    </div>
                    <ProductForm
                        submit={handleSubmit}
                        formState={formState}
                        restaurants={restaurants}
                        handleSelect={handleSelect}
                        handleInputChange={handleInputChange}
                        handleSelectChange={handleSelectChange}
                        handleCheckboxChange={handleCheckboxChange}
                        handleRestaurantPriceChange={handleRestaurantPriceChange}
                        handleRestaurantSupplementChange={handleRestaurantSupplementChange}
                        handleImage={handleImage}
                        allergensTextIcons={allergensTextIcons}
                        isRegistering={isRegistering}
                        imageAux={imageAux}
                        isAddingOrEditing={isAddingOrEditing}
                    />
                </Modal.Body>
            </Modal>
        </Container>
	)
}